import Cookies from 'js-cookie'
import { COOKIE_NAMES } from '@common/constants'

export const getCountryFromCookie = () => Cookies.get(COOKIE_NAMES.GEO_IP)

export const setCountryInCookie = (country: string) => Cookies.set(COOKIE_NAMES.GEO_IP, country)
